import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state() {
    return {
      rootUrl: "https://recruit.ecs-kanai-group.com",
    };
  },
  getters: {
    rootUrl(state) {
      return state.rootUrl;
    },
  },
  mutations: {
    setRootUrl(state, payload) {
      state.rootUrl = payload;
    },
  },
  actions: {
    setRootUrl({ commit }) {
      const rootUrl =
        process.env.NODE_ENV === "production"
          ? "https://recruit.ecs-kanai-group.com"
          : "http://recruit.ecs-kanai-group.com.localhost";
      const payload = {
        rootUrl: rootUrl,
      };
      commit("setRootUrl", payload);
    },
  },
  plugins: [createPersistedState()],
});
